import CDS from "design-system";

interface NewHireDetailsButtonProps {
  onOpen: () => void;
}

export default function NewHireDetailsButton({ onOpen }: NewHireDetailsButtonProps) {
  return (
    <CDS.Text12
      as="button"
      color="content.tertiary"
      cursor="pointer"
      border="1px solid"
      borderColor="gray.200"
      borderRadius="6px"
      px="10px"
      py="3px"
      _hover={{ borderColor: "gray.300", bg: "gray.50" }}
      onClick={onOpen}
    >
      Profile Details
    </CDS.Text12>
  );
}
